import { h, Component } from "preact";
import colorContrast from "color-contrast";

import config from "../../config";
import Share from "../../components/Share";
import TabBar from "../../components/TabBar";
import EventError from "../../components/EventError";
import DatesDisplay from "../../components/DatesDisplay";
import Image from "../../components/Image";

import { css } from "emotion";

const ticketingUrl = config("TICKETING_URL");

const button = css`
  border: none;
  background-color: #6621c0;
  border-radius: 4px;
  margin: 6px;
  color: #fff;
  padding: 0px 14px;
`;

const buttonDisabled = css`
  border: none;
  background-color: #c7c7c7;
  border-radius: 4px;
  margin: 6px;
  color: #323232;
  padding: 0px 14px;
`;

const noEventResults = css({
  maxHeight: 100
});

const EventRow = (event, maxWidth) => {
  const card = css`
    max-width: ${maxWidth};
    height: 148px;
    background-color: #fff;
    margin-bottom: 12px;
    border-radius: 4px;
    box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);
    padding: 24px 20px;
    position: relative;
    @media (max-width: 800px) {
      padding: 0px;
      min-height: 339px;
      height: auto;
    }
  `;
  const imgWrapper = css`
    float: left;
    margin-right: 16px;
    @media (max-width: 800px) {
      float: none;
      display: block;
      margin-right: 0;
    }
  `;

  const cardImg = css`
    width: 200px;
    height: 100px;
    border-radius: 4px;
    @media (max-width: 800px) {
      width: 100%;
      height: auto;
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  `;

  const textWrapper = css`
    float: left;
    max-width: 350px;
    @media (max-width: 800px) {
      float: none;
      display: block;
      padding: 10px 8px;
    }
  `;
  const divider = css`
    display: none;
    @media (max-width: 800px) {
      display: block;
      height: 2px;
      border-bottom: 2px solid #f7faff;
      margin-bottom: 12px;
    }
  `;

  const datesWrapper = css({
    fontSize: 14,
    color: "#5a626c",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipses"
  });

  const priceText = css({
    marginBottom: 2,
    fontSize: 14,
    color: "#5a626c"
  });

  const description = css({
    "@media(max-width:800px)": {
      minHeight: 156
    }
  });

  const eventName = css({
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 400,
    fontSize: 18,
    color: "#323232",
    fontWeight: 600,
    marginBottom: 8
  });

  const addressWrapper = css({
    marginBottom: 2,
    fontSize: 14,
    color: "#5a626c"
  });

  let image = "https://process.filestackapi.com/VbieTVjAQvq5BTkE9vIi";
  if (event.event.featureImage) {
    image = event.event.featureImage.url;
  }
  if (event.event.bannerImage) {
    image = event.event.bannerImage.url;
  }
  let address = "";
  if (event.event.location && event.event.location.address) {
    address = event.event.location.address;
    if (event.event.location.address.length > 40) {
      address = event.event.location.address.substring(0, 40) + "...";
    }
  }
  if (event.event.published) {
    return (
      <a
        href={`${config("TICKETING_URL")}/${event.event.slug}`}
        target="_blank"
        style={{ color: "#323232" }}
      >
        <div className={card}>
          <div className={imgWrapper}>
            <Image
              src={image}
              className={cardImg}
              alt={`${event.event.name} event image`}
            />
          </div>
          <div className={textWrapper}>
            <div className={description}>
              <h3 className={eventName}>{event.event.name}</h3>
              <div className={datesWrapper}>
                <DatesDisplay dates={event.event.dates} singleLine={true} />
              </div>
              <p className={addressWrapper}>{address}</p>
            </div>
            <p className={priceText}>{event.event.ticketsPriceStr}</p>
          </div>
        </div>
      </a>
    );
  } else {
    return null;
  }
};

const OrganiserEvents = ({
  events = [],
  nextPage,
  previousPage,
  changeTab,
  tab,
  page,
  numEvents,
  size,
  loadingEvents,
  maxWidth = "700px"
}) => {
  const eventsPerPage = 20;
  if (!events) {
    return <div style={{ maxWidth: maxWidth }} id={`event-list-${size}`} />;
  }
  let firstPage = page === 0;
  let lastPage = (page + 1) * eventsPerPage >= numEvents;
  return (
    <div
      style={{ maxWidth: maxWidth }}
      id={`event-list-${size}`}
      className="clear-fix"
    >
      {/* <TabBar
        options={[
          { label: "Live Events", value: "live" },
          { label: "Past Events", value: "past" }
        ]}
        selected={tab}
        changeTab={changeTab}
      /> */}
      {loadingEvents ? <div class="loading loading-lg" /> : ""}

      {events.length === 0 && !loadingEvents ? (
        <div className={noEventResults}>
          <EventError type="noEvents" />
        </div>
      ) : null}
      {!loadingEvents &&
        events.map(event => {
          return <EventRow event={event} maxWidth={maxWidth} />;
        })}
      {numEvents <= eventsPerPage ? null : (
        <div style={{ float: "right" }}>
          <button
            className={firstPage ? buttonDisabled : button}
            onClick={previousPage}
            aria-label="Previous"
          >
            Prev
          </button>
          <button
            className={lastPage ? buttonDisabled : button}
            onClick={lastPage ? null : nextPage}
            aria-label="Next"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default OrganiserEvents;



// WEBPACK FOOTER //
// ./routes/organiser/OrganiserEvents.js